module.exports = __webpack_public_path__ + "media/images/top-pattern-62c0ecbe73177fde58c3b8a1e16c9fa2.jpg";